// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import * as ActiveStorage from "@rails/activestorage"
import { Turbo } from "@hotwired/turbo-rails"

import "channels"
import "controllers"

Turbo.session.drive = false

ActiveStorage.start()

require('jquery')
require('swiper')
